module.exports = __webpack_public_path__ + "static/media/logo_share_north_squared.f261537e.png";